import { render, staticRenderFns } from "./tagsListModal.vue?vue&type=template&id=42288e1e&scoped=true&"
import script from "./tagsListModal.vue?vue&type=script&lang=js&"
export * from "./tagsListModal.vue?vue&type=script&lang=js&"
import style0 from "./tagsListModal.vue?vue&type=style&index=0&lang=less&"
import style1 from "./tagsListModal.vue?vue&type=style&index=1&id=42288e1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42288e1e",
  null
  
)

export default component.exports